import { VIP_URL } from '@constants';
import { showConfirmModal } from '@components/ConfirmModal';
import { $isVip, $teamMemberData } from '@stores/memberStores';
import { $tourData } from '@stores/dataStores';

export function showVipModal(storageId: string) {
  if ($teamMemberData.getState().role !== 0) {
    // 对于企业成员，初次点击VIP功能，去掉提示弹窗
    return;
  }
  if ($isVip.getState() || $tourData.getState().expired === 0) {
    // VIP或单作品升级
    return;
  }
  if (localStorage.getItem(storageId)) {
    return;
  }
  showConfirmModal({
    title: '温馨提示',
    content: (
      <div className="mb-5 text-center">
        该功能为720漫游专业版/企业版会员功能，免费用户仅可试用预览该功能效果，开通专业版/企业版后前端播放页面才会生效
      </div>
    ),
    buttonText: '去开通',
    cancelText: '关闭',
  }).then(({ confirmed }) => {
    localStorage.setItem(storageId, 'true');
    if (confirmed) {
      window.open(VIP_URL, '_blank');
    }
  });
}
